import { inline } from 'app/config/inline'
import { selfie } from 'app/config/selfie'
import { sentry } from 'app/config/sentry'
import { telegram } from 'app/config/telegram'
import { test } from 'app/config/test'
import { configure } from 'mobx'
import { controller } from 'store/controller'

export function startup(): void {
  configure({ enforceActions: 'never' })
  sentry()
  controller.startup()
  test()
  inline()
  telegram()
  selfie()
}
